import { useState, useCallback } from "react";
import { OnboardingChip } from "./OnboardingChip";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  AiChat02Icon,
  TextAlignLeft01Icon,
  VoiceIcon,
  NewTwitterIcon,
  YoutubeIcon,
  MusicNote01Icon,
  Attachment01Icon,
  HeadphonesIcon,
  Linkedin01Icon,
  GoogleIcon,
  TiktokIcon,
  DiscoverSquareIcon,
  InstagramIcon,
  FacebookIcon,
} from "@hugeicons/core-free-icons";

const REFERRAL_OPTIONS = [
  { id: "from_work", label: "From work", icon: TextAlignLeft01Icon },
  { id: "ai_tools", label: "AI tools", icon: AiChat02Icon },
  { id: "in_the_news", label: "In the news", icon: Attachment01Icon },
  { id: "newsletter_blog", label: "Newsletter or Blog", icon: HeadphonesIcon },
  { id: "podcast", label: "Podcast", icon: VoiceIcon },
  { id: "friends_school", label: "Friends or School", icon: MusicNote01Icon },
  { id: "linkedin", label: "LinkedIn", icon: Linkedin01Icon },
  { id: "google", label: "Google", icon: GoogleIcon },
  { id: "youtube", label: "YouTube", icon: YoutubeIcon },
  { id: "x_twitter", label: "X", icon: NewTwitterIcon },
  { id: "tiktok", label: "TikTok", icon: TiktokIcon },
  { id: "instagram", label: "Instagram", icon: InstagramIcon },
  { id: "facebook", label: "Facebook", icon: FacebookIcon },
  { id: "other", label: "Other", icon: DiscoverSquareIcon },
] as const;

interface ReferralStepProps {
  value: string | null;
  onChange: (value: string) => void;
}

export function ReferralStep({ value, onChange }: ReferralStepProps) {
  const [selecting, setSelecting] = useState<string | null>(null);

  const handleSelect = useCallback(
    (id: string) => {
      if (selecting) return;
      setSelecting(id);
      setTimeout(() => onChange(id), 600);
    },
    [selecting, onChange],
  );

  const active = selecting ?? value;

  return (
    <div>
      <h1 className="font-display text-3xl font-normal text-foreground">
        How did you hear about Rayloop?
      </h1>

      <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {REFERRAL_OPTIONS.map((option) => (
          <OnboardingChip
            key={option.id}
            icon={<HugeiconsIcon icon={option.icon} className="size-5" />}
            label={option.label}
            selected={active === option.id}
            dismissing={selecting !== null}
            onClick={() => handleSelect(option.id)}
          />
        ))}
      </div>
    </div>
  );
}
